import httpApiCall from "./api.service";
import toastr from "../components/elements/toast";
import { getStorageValue } from "./shared.service";

let profileData = getStorageValue("partnerProfile");
profileData = profileData && profileData[0];

const toastrService = new toastr(true);
const token = getStorageValue("partnerToken");

export const getAllFilesDataApi = async (val: any) => {
  let body = {
    access_token: token,
    partner_id: profileData.partner_id,
    partner_assets_folder_id: val,
  };
  const res = await httpApiCall({
    api: "get_assets_files",
    type: "post",
    body,
  });

  if (res.is_error == 0) {
    return res;
  } else {
    toastrService.showError(res.err);
  }
};

export const getDomainSuggestions = async () => {
  const body = { access_token: token };
  const Alldomains = await httpApiCall({
    api: "get_domain_suggestions",
    type: "post",
    body,
  });

  if (Alldomains && !Alldomains.is_error && Alldomains.domains) {
    return Alldomains.domains;
  } else {
    if (Alldomains) {
      toastrService.showError(Alldomains.original_text || Alldomains.err);
    }
     else {
      toastrService.showError('Server seems busy, Please try again after sometime')
     }
    return [];
  }
};


export const handleInput = (event: any) => {
  if (event.target.selectionStart === 0 && event.code === "Space") {
    event.preventDefault();
  }
};
